export const HOME = "/";

export const SIGNUP = "/signup";
export const LOGIN = "/login";

export const PROFILE = "/profile";

export const NOTIFICATIONS = "/notifications";

export const CREATE_PROJECT = "/create-project";
export const VIEW_PROJECT = "/project/view/:projectId";
export const MANAGE_MATERIALS = "/projects/:projectId/materials";
export const USERS_LIST = "/users"

export const VIEW_SAMPLE = "/view-sample";